import { StokHareketDetayPage } from './../../StokIslemleri/stok-hareket-detay/stok-hareket-detay';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { CalendarComponentOptions } from 'ion2-calendar';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the StokhareketleriPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-stokhareketleri',
  templateUrl: 'stokhareketleri.html',
})
export class StokhareketleriPage {
  @ViewChild('sideNavUrunAra') sideNav;
  vwCari: any = {};
  tarih1: any;
  tarih2: any;
  aranan:any;
  yaziciadi: any;
  FisYaziciAdi: any;
  take:number=100;
  ureticitcno:any;
  HareketListesi = [];
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "primary",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public viewCtrl:ViewController,
    public bllOrtak: BllOrtak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
    public navParams: NavParams) {
   this.ureticitcno=this.ortak.storagePersonelGetir.TCK;
    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");

    }
    if(this.ureticitcno!=null)
    {
      this.vwCari.ID=this.ortak.storagePersonelGetir.ID;
    }
    // var data = new FormData(); 
    //   this.bllOrtak.islem(data, "YaziciGetir", "", false).then(a => {
    //     var Sonuc = <any>a;
    //     this.yaziciadi = Sonuc.SonucObject.BarkodYazici;
    //     this.FisYaziciAdi = Sonuc.SonucObject.YaziciAdi
    //   }
    //   )
 
  
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.closeNav();
    this.HareketGetirFull();
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  Hareketgetir() {
    var formData = new FormData();
    formData.append("aranan", this.vwCari.ID);
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    this.bllOrtak.islem(formData, "CariStokHareketleri", "", true).then(a => {
      var sonuc = <any>a;
      this.HareketListesi = sonuc.SonucObject;
    })
  }
  HareketGetirFull()
  {
    var formData = new FormData();
    formData.append("aranan", this.vwCari.ID);
    // formData.append("take",JSON.stringify(this.take));
     this.bllOrtak.islem(formData, "CariStokHareketleri", "", true).then(a => {
     var sonuc = <any>a;
     this.HareketListesi = sonuc.SonucObject;
    })
  }
excel() {
    var data = [];
    this.HareketListesi.forEach(element => {
      data.push({
        "Isim":this.vwCari.Definition_,
        "Stok Adı": element.StokAdi,
        "Miktar": element.Miktar,
        "Çeşit": element.UrunTur,
        "Sıra": element.SiraNumarasi,
         "Aciklama": element.Aciklama,
          "Tür": element.Satirtipi,
        "Tarih": element.IslemTarihi
      })
    });
    this.ortak.ExportExcel(data, "Hareketler-" + this.vwCari.Definition_).then(a => {
    }).catch(x => {
    });
  }

  kapat(){
    this.viewCtrl.dismiss();
  }
  // detaylar(hareket) {
  //   let modal = this.modalCtrl.create(StokHareketDetayPage, { vwHareket: hareket });
  //   modal.onDidDismiss(data => {
  //     this.ionViewDidLoad();
  //   });
  //   modal.present();
  // }
  hareketSil(hareket)
  {
    var formData = new FormData();
    formData.append("aranan", hareket.ID);
 console.log("hh",hareket);
     this.bllOrtak.islem(formData, "CariStokHareketleriSil", "", true).then(a => {
    this.Hareketgetir();
   
    });
    this.HareketGetirFull() ;
  }
  Islemler(stok) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Cari  İşlemleri',
      buttons: [
       
        {
          text: 'Yazdır',
          handler:()=>{
        this.Yazdir(stok);
          }
         
        },
        {
          text: 'Sil',
          handler:()=>{
        this.hareketSil(stok);
          }
         
        },
        
         {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  Yazdir(stokhar) {
    
    this.aranan=this.vwCari.ID;
      var formData = new FormData();
      formData.append("aranan",stokhar.ID);
      formData.append("yaziciAdi", this.yaziciadi);
      console.log("yaziciAdi", this.yaziciadi);
      this.bllOrtak.islem(formData, "StokhareketYazdirTekli","", false).then(a => {
       
        var sonuc = <any>a;
        this.HareketListesi = sonuc.SonucObject;
  
   
      })
    }
}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stokhareketleri/stokhareketleri.ts